import request from '@/utils/request'; //登录sdk配置 新增配置

export function deleLginConfig(data) {
  return request({
    url: '/pay/del_login_sdk',
    method: 'get',
    params: data
  });
}